export const SELECTED_FIELD = 'selected';
export const DATA_ITEM_KEY = 'id';
